
<div class="card bg-dark">
  <div class="card-body hover-reveal-parent">
    <div class="d-flex align-items-center">
      <div class="mr-auto">
        <h4 translate>{{title}}</h4>
        <div class="metadata">
          <div class="text-muted" *ngIf="token.isEasySharingForBundle || token.isEasySharingForDirectory"><span translate>Created automatically</span></div><a class="text-success" *ngIf="token.activity.length" (click)="showActivityLog()"><i class="fas fa-fw fa-check"></i><span [translate]="usedTimesPlural" [translateParams]="{count: token.activity.length}"></span></a>
          <div class="text-muted" *ngIf="token.expires" [ngbTooltip]="token.expires|date:'medium'"><i class="fas fa-fw fa-calendar"></i><span translate>Expires</span><span class="ml-1">{{token.expires|amUtc|amLocal|amTimeAgo}}</span></div>
          <div class="text-muted" *ngIf="token.createdBy &amp;&amp; identity.user?.id != token.createdBy.id"><i class="fas fa-fw fa-user"></i><span>{{ token.createdBy.displayName }}</span></div>
          <div class="text-muted" *ngIf="showCreatedAt"><i class="fas fa-fw fa-clock"></i>
            <translate>Created</translate><span class="ml-1">{{token.createdAt|amUtc|amLocal|amTimeAgo}}</span>
          </div>
        </div>
      </div>
      <button class="btn btn-secondary hover-reveal mb-2 mr-2" *ngIf="canEdit()" (click)="edit()"><i class="far fa-pencil-alt"></i></button>
      <button class="btn btn-danger hover-reveal mb-2" *ngIf="canDelete()" (click)="delete()"><i class="far fa-trash-alt"></i></button>
    </div>
    <div class="d-flex mt-2">
      <div class="input-group">
        <input class="form-control" type="text" readonly [value]="url" autoselect data-test-qa="sharedLinkInput">
        <div class="input-group-append">
          <button class="btn btn-info" [copyToClipboardButton]="url"><i class="far fa-fw fa-copy"></i></button>
        </div>
      </div><a class="btn btn-info ml-3" [href]="token.url" *ngIf="includeContentLink" target="_blank"><span translate>View content</span></a>
    </div>
  </div>
</div>